export default __webpack_public_path__ + "static/media/2bros-city-news.030c0e31.jpeg";